import React from 'react'
import MostPopularHotelData from './MostPopularHotelData';

import Slider from "react-slick";

// importing the react slick to show the side effect
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

// making previous and next butn

const SampleNextArrow = (props) => {
  const { onClick } = props
  return (
    <div className='control-btn' onClick={onClick}>
      <button className='next'>
        <i className='fa fa-long-arrow-alt-right'></i>
      </button>
    </div>
  )
}
const SamplePrevArrow = (props) => {
  const { onClick } = props
  return (
    <div className='control-btn' onClick={onClick}>
      <button className='prev'>
        <i className='fa fa-long-arrow-alt-left'></i>
      </button>
    </div>
  )
}


function MostPopularHotelCard() {
// this are importing from react slick 
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
    ],
  };

  return (
    <>
    {/* this slider also imporing from react slick */}
    <Slider {...settings}>
      {/* importing the card data of Most popular hotel */}
      {
        MostPopularHotelData.map((value) => {
          return (

            <div className="cards">
              <div className="item">
                <div className="imgae">
                  <img src={value.image} alt="" />
                  <i className='fas fa-map-marker-alt'></i>
                &nbsp;  <label>{value.country}</label>
                </div>
                <div className="rate">
                  <i className='fa fa-star'></i>
                  <i className='fa fa-star'></i>
                  <i className='fa fa-star'></i>
                  <i className='fa fa-star'></i>
                  <i className='fa fa-star'></i>
                </div>
                <div className="details">
                  <h2>{value.name}</h2>
                  <div className="boarder"></div>
                  <h3>{value.price}<span>_Per Night</span></h3>
                </div>
              </div>
            </div>

          )
        })
      }
</Slider>
    </>
  )
}

export default MostPopularHotelCard;